import { Component, OnInit } from '@angular/core';
import { ModelRestService } from '../../model-rest.service';
import { SessionService } from '../../session.service';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { Segment } from '../../model/segment';
import { Response } from '../../model/response';
import { RouteBooking } from '../../model/routebooking';
import { SeatBooking } from '../../model/seatbooking';
import { Cost } from '../../model/cost';
import { HttpClient } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';

/**Componente del paso donde encontaremos el captcha para saber que no se es un bot */
@Component({
  selector: 'app-commit',
  templateUrl: './commit.component.html',
  styleUrls: ['./commit.component.css']
})
export class CommitComponent implements OnInit {

  constructor(
    private translate: TranslateService,
    private location:Location, 
    private model:ModelRestService, 
    public session:SessionService,
    private router:Router,
    private http: HttpClient) { }

    public is_getting_quote:boolean = false;
    public is_captcha_solved:boolean = false;
    public segments:Segment[] = [];
    public displayModal = false;
    public notifTitle = "";
    public notifBody = "";
    public notifBody1 = "";
    public isLoading = true;
    public route ;
    public buttonFlag = null;
    public commit;
    public routeX = "/reservaciones/" + this.session.route.name + "/confirmar";
    public token = "";
    public count:number= 0;
    public labelClass:string;
     /**Valida que exista un datos en session, si no existe te regresa al paso de reservaciones */
  ngOnInit() {
    if(!this.session || !this.session.route ||  !this.session.query || !this.session.segments || !this.session.rb){
      this.router.navigate(["/reservaciones"]);return;
    }
    this.commit = this.translate.instant('Com1-P11');
    this.segments = this.session.mkUnifiedSegments();
    this.session.segments = this.segments;
    this.is_captcha_solved = false;
    this.is_getting_quote = true;
    this.session.rb.status = RouteBooking.editing;
    this.model.saveRouteBooking(this.session.rb).subscribe((response:Response<RouteBooking>)=>{
     
      this.session.rb = response.data;
      this.is_getting_quote = false;
    });
    this.count = 0 ;
    this.labelClass =this.session.query.class.toString();
    console.clear();
  }
/**Función para el boton de regresar al paso anterior */
  public goBack(){
    this.location.back();
  }
/**Función para ocultar el model */
  ocultarModel(){
    this.displayModal = false;
  }
/**Función que te manda un aviso si quieres continuar al pago si es asi te redirige al paso de pago */
  public bookIt(){
    
    let r = JSON.stringify( this.session.rb )
    sessionStorage.setItem('route', r )
    //this.isLoading = false
    //this.displayModal = true;
    //this.notifTitle = "";
    //this.notifBody = "¿Desea proceder al pago?";       
    this.route = "/"+this.session.route.name+"/pago";
    this.router.navigate(["/" + this.session.route.name + "/pago"]);
    
  }
  /**Función que obtine el costo del viaje*/
  public getCosts():Cost[]{
    var costs={};
   
    for(var i=0;i<this.session.rb.seats.length;i++){
      let sb:SeatBooking = this.session.rb.seats[i];
      let a:number = sb.cost.amount;
      let b:string = sb.cost.currency;
      if(!costs[b]){
        costs[b] = new Cost();
        costs[b].currency = b;
        costs[b].amount = 0;
      }
      costs[b].amount+=a;
    }
    var costs2:Cost[] = [];
    for(var j in costs){
      let c:Cost = costs[j];
      costs2.push(c);
    }
    return costs2;
  }
  /**Función del captcha */
  captchaSolved(captchaResponse: string){
        
    this.buttonFlag = null;
    this.is_captcha_solved=false;
    this.commit = this.translate.instant('Com1-P09');
    this.token = captchaResponse;
       
    this.is_captcha_solved=true;
    return ;
    this.model.getIsValidRecaptcha(captchaResponse).subscribe((data)=>{
      
      if(data.success)
      {
        if(data.data.success.toUpperCase() =="TRUE")
        {

          this.is_captcha_solved=true;

        }

      }else
      {

        this.is_captcha_solved=false;

      }

      if(!this.is_captcha_solved)
      {
        alert("No se pudo validar el recaptcha");
      }
         
    });
   
  }
  public haveSeniorCitizen(){

    var totalSenior = this.session.query.passengers[3];

    if(totalSenior>0)
    {
      return true;
    }else
    {
      return false;
    }

  }
}
